<template>
  <div class="main">
    <el-container>
      <el-header>健康水平实验评估系统</el-header>
      <el-main>
        <el-row>
          <el-col
            :xs="{ span: 24, offset: 0 }"
            :sm="{ span: 24, offset: 0 }"
            :md="{ span: 16, offset: 4 }"
            :lg="{ span: 12, offset: 6 }"
            :xl="{ span: 12, offset: 6 }"
            class="form-box"
          >
            <el-form
              :model="basic"
              :rules="rulesBasic"
              ref="ruleForm"
              label-width="120px"
              class="demo-ruleForm"
            >
              <div class="form-head">1.基本信息</div>
              <el-form-item label="姓名" prop="">
                <el-input v-model="basic.name" placeholder=""></el-input>
              </el-form-item>
              <el-form-item label="性别" prop="category">
                <el-radio v-model="basic.category" label="男">男</el-radio>
                <el-radio v-model="basic.category" label="女">女</el-radio>
              </el-form-item>
              <el-form-item label="年龄" prop="age">
                <el-input
                  :controls="false"
                  v-model.number="basic.age"
                ></el-input>
              </el-form-item>
              <el-form-item label="身高" :value="''" prop="height">
                <el-input
                  :controls="false"
                  v-model="basic.height"
                  placeholder="cm"
                ></el-input>
              </el-form-item>
              <el-form-item label="体重" :value="''" prop="weight">
                <el-input
                  :controls="false"
                  v-model="basic.weight"
                  placeholder="Kg"
                ></el-input>
              </el-form-item>
              <el-form-item label="腹围(腰围)" :value="''" prop="waist">
                <el-input
                  :controls="false"
                  v-model="basic.waist"
                  placeholder="cm"
                ></el-input>
              </el-form-item>
              <el-form-item label="收缩压" :value="''" prop="pressed">
                <el-input
                  :controls="false"
                  v-model.number="basic.pressed"
                  placeholder="mmHg"
                ></el-input>
              </el-form-item>
              <el-form-item label="舒张压" :value="''" prop="relaxed">
                <el-input
                  :controls="false"
                  v-model.number="basic.relaxed"
                  placeholder="mmHg"
                ></el-input>
              </el-form-item>
              <el-form-item label="检查时间" prop="date1">
                <el-col>
                  <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    v-model="basic.date1"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-col>
              </el-form-item>
            </el-form>
            <el-form
              :model="test"
              :rules="rulesTest"
              ref="ruleTest"
              label-width="120px"
              class="demo-ruleForm"
            >
              <div class="form-head">2.实验指标</div>
              <el-form-item label="白蛋白" prop="protn">
                <el-input
                  :value="''"
                  :controls="false"
                  v-model="test.protn"
                  placeholder="g/L"
                ></el-input>
              </el-form-item>
              <el-form-item label="血糖" prop="glucose">
                <el-input
                  :value="''"
                  :controls="false"
                  v-model="test.glucose"
                  placeholder="mmol/L"
                ></el-input>
              </el-form-item>
              <el-form-item label="肝功" prop="liverf">
                <el-select v-model="test.liverf">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
                <div class="tips">
                  总蛋白、总胆红素、直接胆红素、总胆汁酸等有一项异常就为异常
                </div>
              </el-form-item>
              <el-form-item label="酶学" prop="enzyme">
                <el-select v-model="test.enzyme">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
                <div class="tips">
                  谷丙、谷草、Ɣ转肽酶、碱性磷酸酶等有一项异常就为异常
                </div>
              </el-form-item>
              <el-form-item label="肾功" prop="kidneyf">
                <el-select v-model="test.kidneyf">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
                <div class="tips">肌酐、尿素、尿酸等有一项异常就为异常</div>
              </el-form-item>
              <el-form-item label="血脂" prop="fat">
                <el-select v-model="test.fat">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
                <div class="tips">
                  甘油三酯、总胆固醇、高密度脂蛋白、低密度脂蛋白等有一项异常就为异常
                </div>
              </el-form-item>
            </el-form>
            <el-form :model="opt" label-width="120px" class="demo-ruleForm">
              <div class="form-head">3.选做项目</div>
              <el-form-item label="超敏C反应蛋白" prop="cprotn">
                <el-select v-model="opt.cprotn">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="血细胞分析" prop="cell">
                <el-select v-model="opt.cell">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
                <div class="tips">有一项异常就为异常</div>
              </el-form-item>
              <el-form-item label="尿液分析" prop="piss">
                <el-select v-model="opt.piss">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
                <div class="tips">有一项异常就为异常</div>
              </el-form-item>
              <el-form-item label="心电图" prop="hearth">
                <el-select v-model="opt.hearth">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
                <div class="tips">有一项异常就为异常</div>
              </el-form-item>
              <el-form-item label="胸部影像学检查" prop="chest">
                <el-select v-model="opt.chest">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
                <div class="tips">有一项异常就为异常</div>
              </el-form-item>
              <el-form-item label="B超检查" prop="BSonar">
                <el-select v-model="opt.BSonar">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="已查" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-form
              :model="bsonar"
              label-width="120px"
              class="demo-ruleForm"
              v-show="opt.BSonar && opt.BSonar != '-1'"
            >
              <div class="form-head">4.彩超检查</div>
              <el-form-item label="肝" prop="liver">
                <el-select v-model="bsonar.liver">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="胆" prop="gall">
                <el-select v-model="bsonar.gall">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="脾" prop="spleen">
                <el-select v-model="bsonar.spleen">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="胰" prop="pancreas">
                <el-select v-model="bsonar.pancreas">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="肾" prop="kidney">
                <el-select v-model="bsonar.kidney">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="膀胱" prop="bladder">
                <el-select v-model="bsonar.bladder">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="输尿管" prop="ureter">
                <el-select v-model="bsonar.ureter">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="basic.category == '男' ? '前列腺' : '子宫附件'"
                prop="sex"
              >
                <!-- <el-form-item label="子宫附件" prop="region"> -->
                <!-- 此处 性别是女的话显示：子宫附件 -->
                <el-select v-model="bsonar.sex">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="甲状腺" prop="thyroid">
                <el-select v-model="bsonar.thyroid">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="颈部血管" prop="neck">
                <el-select v-model="bsonar.neck">
                  <el-option label="未查" value="-1"></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="异常" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-button type="primary" @click="submit()">提交</el-button>
            <el-button type="primary" plain @click="$router.replace('/')"
              >返回</el-button
            >
          </el-col>
        </el-row>
      </el-main>
      <!-- <el-footer>版本 V3.0</el-footer> -->
    </el-container>
  </div>
</template>

<script>
export default {
  name: "Form",
  data() {
    return {
      radio: "1",
      basic: {
        name: "",
        category: "",
        age: "",
        height: "",
        weight: "",
        waist: "",
        pressed: "",
        relaxed: "",
        date1: "",
      },
      test: {
        protn: "",
        glucose: "",
        liverf: "",
        enzyme: "",
        kidneyf: "",
        fat: "",
      },
      opt: {
        cprotn: "-1",
        cell: "-1",
        piss: "-1",
        hearth: "-1",
        chest: "-1",
        BSonar: "-1",
      },
      bsonar: {
        liver: "-1",
        gall: "-1",
        spleen: "-1",
        pancreas: "-1",
        kidney: "-1",
        bladder: "-1",
        ureter: "-1",
        sex: "-1",
        thyroid: "-1",
        neck: "-1",
      },
    };
  },
  computed: {
    rulesBasic() {
      let rules = {};
      for (let key in this.basic) {
        if (key !== "name" && key !== "date1") {
          rules[key] = [
            {
              required: true,
              validator: (rule, value, cb) =>
                !value || value == ""
                  ? cb(new Error("不能空项，请自行测量"))
                  : key == "category" || /^\d*\.*\d+$/.test(value)
                  ? cb()
                  : cb(new Error("请输入正确的数值")),
              trigger: "blur",
            },
          ];
        }
      }
      return rules;
    },
    rulesTest() {
      let rules = {};
      for (let key in this.test) {
        if (key == "protn" || key == "glucose") {
          rules[key] = [
            {
              required: true,
              validator: (rule, value, cb) =>
                !value || value == ""
                  ? cb(new Error("不能空项，请到体检中心检测血清生化"))
                  : /^\d*\.*\d+$/.test(value)
                  ? cb()
                  : cb(new Error("请输入正确的数值")),
              trigger: "blur",
            },
          ];
        } else {
          rules[key] = [
            {
              required: true,
              validator: (rule, value, cb) =>
                !value || value == "-1"
                  ? cb(new Error("不能空项，请到体检中心检测血清生化"))
                  : cb(),
              trigger: "change",
            },
          ];
        }
      }
      return rules;
    },
  },
  methods: {
    submit() {
      this.$refs["ruleForm"].validate((valid1) => {
        this.$refs["ruleTest"].validate((valid2) => {
          if (valid1 && valid2) {
            this.$store.commit("setForm", { key: "basic", data: this.basic });
            this.$store.commit("setForm", { key: "test", data: this.test });
            this.$store.commit("setForm", { key: "opt", data: this.opt });
            this.$store.commit("setForm", { key: "bsonar", data: this.bsonar });
            this.$router.push({
              path: "/report",
              query: { mode: this.$route.query.mode },
            });
          } else {
            this.$message.error("请正确填写所有参数后再提交");
            return false;
          }
        });
      });
    },
    save() {
      this.$store.commit("setForm", { key: "basic", data: this.basic });
      this.$store.commit("setForm", { key: "test", data: this.test });
      this.$store.commit("setForm", { key: "opt", data: this.opt });
      this.$store.commit("setForm", { key: "bsonar", data: this.bsonar });
      this.$router.back(-1);
    },
  },
  mounted() {
    if (this.$route.query.mode == "demo") {
      console.log(this.$store.state.demoForm.basic);
      this.basic = { ...this.$store.state.demoForm.basic };
      this.test = { ...this.$store.state.demoForm.test };
      this.opt = { ...this.$store.state.demoForm.opt };
      this.bsonar = { ...this.$store.state.demoForm.bsonar };
    } else if (
      this.$route.query.mode != "new" &&
      this.$store.state.form.basic.age != ""
    ) {
      this.basic = this.$store.state.form.basic;
      this.test = this.$store.state.form.test;
      this.opt = this.$store.state.form.opt;
      this.bsonar = this.$store.state.form.bsonar;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>
.tips {
  text-align: left;
  color: #ccc;
}
.form-head {
  padding: 10px 30px;
  background: $green;
  color: #fff;
  margin: 15px 0;
  border-radius: 5px;
}
.box-head {
  background-color: $green;
  height: 60px;
  line-height: 60px;
  color: #fff;
  font-size: 18px;
}
.el-select {
  width: 100%;
}
</style>
